import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  SettlementMethodService,
  SettlementMethodContainerModel,
  Pagination,
  ApiVisa
} from 'blg-akaun-ts-lib';
import { ReplaySubject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../shared-utilities/visa';


@Component({
  selector: 'app-ng-select-settlement-methods',
  templateUrl: './select-settlement-method.component.html',
  styleUrls: ['./select-settlement-method.component.scss']
})

export class SelectSettlementMethodDropDownComponent implements OnInit, OnDestroy {

  @Input() settlement: FormControl;
  apiVisa = AppConfig.apiVisa;
  @Output() settlementChange = new EventEmitter<FormControl>();
  @Output() settlementType = new EventEmitter<SettlementMethodContainerModel>();

  private subs = new SubSink();


  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<SettlementMethodContainerModel[]> = new ReplaySubject<SettlementMethodContainerModel[]>(1);
  settlementList: SettlementMethodContainerModel[];

  constructor( 
    private sms: SettlementMethodService,
  ) {}

  ngOnInit() {
    this.subs.sink = this.sms.getByCriteria(new Pagination(), this.apiVisa).subscribe(
      {next: resolve => {
        resolve.data.sort((a, b) => {
          const sortA = a.bl_fi_mst_item_exts.find(x => x.param_code === 'SORT_CODE')?.value_string.toString();
          const sortB = b.bl_fi_mst_item_exts.find(x => x.param_code === 'SORT_CODE')?.value_string.toString();
          const sortValueA = sortA?.length ? parseInt(sortA, 10) : 0;
          const sortValueB = sortB?.length ? parseInt(sortB, 10) : 0;
          return sortValueA - sortValueB;
        });
        this.settlementList = resolve.data;
        this.filteredOptions$.next(this.settlementList);
      }});
    // if (this.currency.value) {
    //   this.subs.sink = this.currencyService.getByGuid(this.currency.value, this.apiVisa).subscribe( resolved => {
    //     this.branchList = [resolved.data];
    //     this.filteredOptions$.next([resolved.data]);
    //     this.onSelect(resolved.data.bl_fi_mst_branch.guid.toString());
    //   });
    // }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterSettlement(resolve)});
  }

  filterSettlement(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.settlementList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.settlementList.filter(c => c.bl_fi_mst_item_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }
  }

  onSelectionChange(e: string) {
    const sm = this.settlementList.find(i => i.bl_fi_mst_item_hdr.guid.includes(e))
    this.settlementType.emit(sm);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
